// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary_CheckoutSummary__3PsXi","Alert":"CheckoutSummary_Alert__26V9T"};